export default {
    setfolderInfoToGetCurrentPath(state, payload) {
        state.currentPathFolderInfo = payload;
    },
};